import { FormattedMessage, FormattedNumber } from 'react-intl';

import { ProductType } from '@xing-com/crate-common-graphql-types';
import { BodyCopy, Headline } from '@xing-com/typography';

import { BubbleContainer } from './bubbles.styles';

interface DiscountBubbleProps {
  product: ProductType;
  percentage: number;
  withAsterisk?: boolean;
  discountBubbleMessage: string;
}

export const DiscountBubble: React.FC<DiscountBubbleProps> = (props) => {
  const {
    percentage,
    withAsterisk = false,
    product,
    discountBubbleMessage,
  } = props;

  const isPremium = product === ProductType.Premium;

  return (
    <BubbleContainer data-testid="discount-bubble" $isPremium={isPremium}>
      <Headline
        as="p"
        size="xxlarge"
        sizeConfined="xxlarge"
        sizeWide="xxxlarge"
        noMargin
      >
        <FormattedNumber value={percentage} style="percent" />
      </Headline>
      <BodyCopy
        size="xsmall"
        sizeConfined="xsmall"
        sizeWide="small"
        lineHeight="dense"
        noMargin
      >
        <FormattedMessage id={discountBubbleMessage} />
        {withAsterisk ? '*' : null}
      </BodyCopy>
    </BubbleContainer>
  );
};
